import { Col, ColorPicker as ColorPickerAntd, Divider, Row, theme } from "antd";
import { generate, green, presetPalettes, red, cyan } from "@ant-design/colors";
import { useCallback } from "react";
const genPresets = (presets = presetPalettes) =>
  Object.entries(presets).map(([label, colors]) => ({
    label,
    colors,
  }));

const ColorPicker = (props) => {
  const { token } = theme.useToken();
  const presets = genPresets({
    primary: generate(token.colorPrimary),
    red,
    green,
    cyan,
  });

  const customPanelRender = useCallback(
    (_, { components: { Picker, Presets } }) => (
      <Row justify="space-between" wrap={false}>
        <Col span={12}>
          <Presets />
        </Col>
        <Divider
          type="vertical"
          style={{
            height: "auto",
          }}
        />
        <Col flex="auto">
          <Picker />
        </Col>
      </Row>
    ),
    []
  );

  return (
    <ColorPickerAntd
      styles={{
        popupOverlayInner: {
          width: 500,
        },
      }}
      presets={presets}
      panelRender={customPanelRender}
      {...props}
    />
  );
};

export default ColorPicker;
